/* eslint no-eval: 0 */
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import AbacusView from '../../base/abacus';
import Result from '../../base/result';
import './index.less';
import { motion } from 'framer-motion';
import { t } from '../../../languages';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';
import { getRandomMessage2 } from '../utils';

const SumSubstractionSeries = (props) => {
    const [state, setState] = useState({
        eid: 0,
        results: [],
        times: [],
        numberinbox: 0,
        message: null,
        message2: null,
        showresults: false,
        moved: 0,
        completed: [],
        currentOption: null,
        maxForOption: 0,
        currentOps: 0,
        currentResult: 0,
        timer: new Date().getTime(),
    });

    const [initMoment, setInitMoment] = useState(0);


    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            timer: new Date().getTime(),
        }));
        setInitMoment(moment());

    }, []);

    const handleRate = () => {
        const params = props.params;
        const { currentOps, currentOption, maxForOption } = state;

        const splitJoin =
            params.ops === '+'
                ? `${currentOps * currentOption} + ${currentOption}`
                : `${maxForOption - currentOps * currentOption} - ${currentOption}`;
        const currentNumber = eval(splitJoin);

        const is_ok_result = currentNumber === state.numberinbox ? 1 : 0;

        if (is_ok_result) {
            const nextNumber =
                params.ops === '+'
                    ? currentNumber + currentOption
                    : currentNumber - currentOption;
            const max = params.max;

            if (
                (params.ops === '+' && nextNumber > max) ||
                (params.ops === '-' && nextNumber < 0)
            ) {
                const completed = [...state.completed, currentOption];
                const message = t(props.lang, 'rightserie');
                const message2 = t(props.lang, getRandomMessage2('great'));

                setState((prevState) => ({
                    ...prevState,
                    message,
                    message2,
                    completed,
                    currentResult: 1,
                    moved: 0,
                }));
            } else {
                setState((prevState) => ({
                    ...prevState,
                    currentOps: prevState.currentOps + 1,
                    currentResult: 1,
                    moved: 0,
                }));
            }
        } else {
            const message = `${t(props.lang, 'wrong')}, ${splitJoin} = ${currentNumber}`;
            const message2 = t(props.lang, getRandomMessage2('nodiscorage'));

            setState((prevState) => ({
                ...prevState,
                message,
                message2,
                currentResult: 0,
            }));
        }
    };

    const handleNext = () => {
        const { completed, results, times } = state;
        const params = props.params;

        const currentResult = state.currentResult;
        if (currentResult) results.push(currentResult);

        if (completed.length <= params.finish - params.init) {
            setState((prevState) => ({
                ...prevState,
                currentOption: null,
                numberinbox: 0,
                message: null,
                message2: null,
                moved: 0,
                currentOps: 0,
                results,
                times,
            }));
        } else {
            const num = params.num;
            const hits = results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = true;
            const uid = props.uid;
            const eid = props.eid;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            const is_test = params.is_test ? params.is_test : false;

            props.saveResult(uid, `${uid}-${eid}`, {
                id: 'SSS',
                uid,
                eid,
                p: passed,
                h: hits,
                e: errors,
                c: passed ? coins : 0,
                r: results,
                s: state.series, et: elapsedTime,
            });

            const newResults = [hits];
            if (!is_test) {
                setState((prevState) => ({
                    ...prevState,
                    results: newResults,
                    showresults: true,
                }));
            }
        }
    };

    const handleRepeat = () => {
        setState({
            eid: 0,
            results: [],
            times: [],
            numberinbox: 0,
            message: null,
            message2: null,
            showresults: false,
            moved: 0,
            completed: [],
            currentOption: null,
            maxForOption: 0,
            currentOps: 0,
            currentResult: 0,
            timer: new Date().getTime(),
        });
    };

    const handleChange = (num) => {
        setState((prevState) => ({
            ...prevState,
            numberinbox: num,
            moved: 1,
        }));
    };

    const handleOption = (num) => {
        const params = props.params;
        const maxForOption =
            params.ops === '+' ? 0 : Math.floor(params.max / num) * num;

        setState((prevState) => ({
            ...prevState,
            currentOption: num,
            maxForOption,
            numberinbox: maxForOption,
        }));
    };

    const {
        currentOption,
        currentResult,
        completed,
        currentOps,
        message,
        message2,
        showresults,
        numberinbox,
    } = state;

    const messagestyle = message ? (!currentResult ? ' error' : ' valid') : '';
    const percent = Math.round((currentOps / props.params.num) * 100);

    const is_test = props.params.is_test ? props.params.is_test : false;
    const params = {
        ...props.params,
        rows: props.params ? props.params.rows : 1,
        number: numberinbox,
    };

    const init = props.params.init;
    const finish = props.params.finish;
    const options = Array.from(Array(finish - init + 1), (_, i) => i + init);
    const currentNumber = `${props.params.ops}${currentOption}`;

    if (!showresults) {
        return (
            <Row className="exercise">
                <BackMusic source={'random'} />
                
                <ChangeOrientation to={'portrait'} />

                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}

                <Col span={24} className="exercise-body">
                    <ExerciseBlocker show={messagestyle} />

                    <section className="sumsubstractionseries">
                        {!currentOption && (
                            <article key="selection" className="selection">
                                {options.map((el, idx) => (
                                    <Button
                                        key={idx}
                                        disabled={completed.includes(el)}
                                        className="round"
                                        onClick={() => handleOption(el)}
                                    >
                                        {el}
                                    </Button>
                                ))}
                            </article>
                        )}

                        {currentOption && (
                            <div>
                                <AbacusView
                                    params={params}
                                    isactive={true}
                                    hidelatframe={true}
                                    hideheaderlabels={true}
                                    onChange={handleChange}
                                />
                                <article className="number" key={currentOption}>
                                    <motion.div
                                        animate={{ scale: 2 }}
                                        transition={{ duration: 1 }}
                                        className="the-number"
                                        key={currentOps}
                                    >
                                        {currentNumber}
                                    </motion.div>
                                </article>
                            </div>
                        )}
                    </section>
                </Col>

                <Col span={24}>
                    <Row className={`botones${messagestyle}`}>
                        <Col span={24} className="message">
                            {message}
                        </Col>

                        {!message && currentOption && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleRate}
                                    style={{ width: '90%' }}
                                    disabled={!state.moved}
                                >
                                    {t(props.lang, 'grade')}
                                </Button>
                            </Col>
                        )}

                        {message && currentOption && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleNext}
                                    style={{ width: '90%' }}
                                >
                                    {t(props.lang, 'next')}
                                </Button>
                            </Col>
                        )}

                        {message2 && (
                            <Col span={24} className="message">
                                {message2}
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        );
    } else {
        return (
            <Result
                params={props.params}
                results={state.results}
                handleRepeat={handleRepeat}
                handleCancel={props.handleCancel}
                lang={props.lang}
            />
        );
    }
};

export default SumSubstractionSeries;